import { gql } from '@apollo/client';

export const ADD_USERS_TO_GROUP = gql`
  mutation AddUsersToGroup($input: addUsersToGroupInput!) {
    addUsersToGroup(input: $input) {
      return_status
    }
  }
`;
